import React, { useEffect, useState, useContext } from "react";
import Icons from "../../utils/components/icons";
import LoadingSpinner from "../../utils/components/common/loadingSpinner/LoadingSpinner";
import Pagination from "../../utils/components/common/pagination";
import { UserContext } from "../../layouts/MainLayout";
import { useTranslation } from "react-i18next";
import { getSiteByTenantId } from "../../services/SitesService";
import "./SitesDashboard.scss";

import EmptyScreen from "../../utils/components/common/EmptyScreen/EmptyScreen";

const SitesDashboard = () => {
  const { userData } = useContext(UserContext);
  const { t } = useTranslation("sitesManagement");

  const [counterSort, setCounterSort] = useState(2);
  const [activeIndex, setActiveIndex] = useState(0);
  const [siteDetails, setSiteDetails] = useState([]);
  const [siteLists, setSiteLists] = useState([]);
  const [siteCount, setSiteCount] = useState(0);
  const [displayData, setDisplayData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [showSites, setShowSites] = useState(false);
  const [pageCount, setPageCount] = useState(1);
  const [pageTotalCount, setPageTotalCount] = useState(0);
  const itemsPerPage = 10;
  const queryCount = 10;
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const displayedTableData = displayData.slice(startIndex, endIndex);

  const getSiteDetails = async () => {
    setIsLoading(true);
    const queryParams = {
      tenantId: userData.OrganizationID,
      siteStatus: "All",
      size: queryCount,
      pageNo: pageCount,
      sort: [
        {
          SiteName: "ASC",
        },
      ],
    };
    getSiteByTenantId(queryParams)
      .then((response) => {
        setSiteDetails(response.data);
        setSiteCount(response.data.TotalSiteCount);
        setPageTotalCount(Math.ceil(response.data.TotalSiteCount / queryCount));
        setSiteLists(response.data.SiteList);
        setIsLoading(false);
        setShowSites(true);
      })
      .catch((error) => {
        // console.log(error);
        setIsLoading(false);
        setShowSites(true);
      });
  };

  useEffect(() => {
    getSiteDetails();
  }, [pageCount, userData]);

  useEffect(() => {
    let copiedData = JSON.parse(JSON.stringify(siteLists));
    setDisplayData([...copiedData]);
  }, [siteDetails]);

  const columList = [
    { key: "SiteName", label: "Site Name", val: "asc", clickCount: 1 },
  ];

  const handleAscendingSorting = () => {
    const sortMapData = [...displayData];
    sortMapData.sort((a, b) => a.SiteName.localeCompare(b.SiteName));
    setDisplayData(sortMapData);
  };

  const handleDescendingSorting = () => {
    const sortMapData = [...displayData];
    sortMapData.sort((a, b) => b.SiteName.localeCompare(a.SiteName));
    setDisplayData(sortMapData);
  };

  useEffect(() => {
    handleAscendingSorting();
  }, []);

  const handleToggle = (index) => {
    setActiveIndex(index === activeIndex ? 1 - index : index);
  };

  const handleSort = () => {
    setCounterSort(counterSort + 1);

    if (counterSort === 1) {
      handleAscendingSorting();
    } else if (counterSort === 2) {
      handleDescendingSorting();
    } else if (counterSort === 3) {
      setDisplayData(siteLists);
      setCounterSort(1);
    }
  };

  const handlePageChange = (item) => {
    setPageCount(item + 1);
  };

  return (
    <div className="siteDashboardBodyInner">
      <div className="bodyContainer">
        <div className="bodyHeader fixSubHeader">
          <div id="sites_count" className="">
            {showSites && (
              <span className="sitesCount">Sites - {siteCount} </span>
            )}
          </div>
          {showSites && (
            <button
              id="add_site"
              type="button"
              className="btn btn-info d-flex align-items-center addSiteBtn disabled-btn"
              disabled
              title="Not Supported"
            >
              {Icons.addIcon}
              <span className="addtextSite">Add Site</span>
            </button>
          )}
        </div>

        {showSites && displayedTableData.length ? (
          <div className="mainBody">
            <div className="table-wrapper">
              <table
                className="table table-striped  sitesTable"
                id="site_list_table"
              >
                <thead>
                  <tr>
                    <th scope="col" width="05%" className="disabledStatus"></th>
                    {columList.map((item, index) => (
                      <th
                        scope="col"
                        key={``}
                        width="20%"
                        className="alignLeft site-name"
                      >
                        <div
                          id="site"
                          className="sortIconWrapper"
                          onClick={() => {
                            handleSort();
                            handleToggle(1);
                          }}
                        >
                          <span>Site Name</span>
                          <div className="sortIcons">
                            <button
                              type="button"
                              className={`icon1 ${
                                activeIndex === 0 ? "active" : ""
                              } `}
                              id="site_sort_asc"
                              onClick={() => {
                                handleAscendingSorting();
                                handleToggle(0);
                              }}
                            >
                              {Icons.upArrowIcon}
                            </button>
                            <button
                              type="button"
                              className={`icon1 ${
                                activeIndex === 1 ? "active" : ""
                              }`}
                              id="site_sort_desc"
                            >
                              {Icons.downArrowIcon}
                            </button>
                          </div>
                        </div>
                      </th>
                    ))}
                    <th
                      scope="col"
                      width="55%"
                      className="alignLeft site-address"
                      id="site_address"
                    >
                      Site Address
                    </th>
                    <th scope="col" width="25%" className="action" id="action">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {displayedTableData.map((item, index) => {
                    return (
                      <tr key={`${index + 1}`}>
                        <th scope="row" className="disable-status-value">
                          {item.SiteStatus === "Disabled" ? (
                            <div className="disabled">{Icons.disabledIcon}</div>
                          ) : null}
                        </th>
                        <td className="alignLeft site-name-value">{item.SiteName}</td>
                        <td className="alignLeft site-address-value">{item.SiteAddress}</td>
                        <td className="buttonTable action-value">
                          <button
                            id="edit_site"
                            type="button"
                            className="btn btn-info editSiteBtn disabled-btn"
                            title="Not Supported"
                          >
                            {Icons.editIcon}
                            <span>Edit Site</span>
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        ) : (
          <></>
        )}

        {/* No Data Section Starts */}
        {showSites && !displayedTableData.length && (
          <div className="d-flex align-items-center justify-content-center h-100">
            <EmptyScreen
              img={Icons.emptyScreenSitesIcon}
              title={t("empty_screen_title")}
              desc={t("empty_screen_desc")}
            />
          </div>
        )}
        {/* No Data Section Ends */}
      </div>

      <div className="bodyFooter footerFixed">
        <Pagination
          currentPage={pageCount - 1}
          totalPages={pageTotalCount}
          pageCallBack={handlePageChange}
        />
      </div>

      {/* Loader Section Starts */}
      {isLoading ? <LoadingSpinner /> : <></>}
      {/* Loader Section Ends */}
    </div>
  );
};

export default SitesDashboard;
